/**
 * Spanish (es) mappings for MobileNavigation
 */

export const mobileNavigationES = {
  // User stats and display
  "points": "puntos",
  "today": "hoy",
  "Novice Oracle": "Oráculo Novato",
  "Daily Streak": "Racha Diaria",
  "days": "días",

  // Pro status
  "PRO": "PRO",
  "Upgrade to Pro?": "¿Actualizar a Pro?",

  // Navigation items
  "Home": "Inicio",
  "Chat": "Conversar",
  "AI Exchange": "Intercambio IA",
  "Sports Hub": "Centro Deportivo",
  "Community": "Comunidad",
  "Settings": "Configuración",
  "Upgrade": "Actualizar",
  "Help": "Ayuda",
  "About Us": "Acerca de Nosotros",
  "Chat Archive": "Archivo de Conversaciones",
  "Sign Out": "Cerrar Sesión",

  // Footer
  "Mobile Version 2.0.0": "Versión Móvil 2.0.0",
  "© 2025 PickStar": "© 2025 PickStar",
};
